import { render, staticRenderFns } from "./eidtLevel1TagModal.vue?vue&type=template&id=0165cbd1&scoped=true"
import script from "./eidtLevel1TagModal.vue?vue&type=script&lang=js"
export * from "./eidtLevel1TagModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0165cbd1",
  null
  
)

export default component.exports